import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { BdOrganisationService } from "./BdOrganisationService";

interface BdOrganisationServiceProviderProps {
  children: React.ReactNode;
}

export const BdOrganisationServiceContext = React.createContext<BdOrganisationService | undefined>(
  undefined
);

export const BdOrganisationServiceProvider: React.FC<BdOrganisationServiceProviderProps> = ({
  children,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new BdOrganisationService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return (
    <BdOrganisationServiceContext.Provider value={service}>
      {children}
    </BdOrganisationServiceContext.Provider>
  );
};

export const useBdOrganisationService = (): BdOrganisationService => {
  const context = React.useContext(BdOrganisationServiceContext);
  if (context === undefined) {
    throw new Error("useBdOrganisationService must be used within a BdOrganisationServiceProvider");
  }
  return context;
};
